var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogofondo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 251,
    viewBox: "0 0 200 251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_2113",
    x: 0,
    y: 0,
    width: 200,
    height: 251,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_52",
    "data-name": "Rect\\xE1ngulo 52",
    width: 59.544,
    height: 2.224,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -21.771,
    y1: 705.025,
    x2: -21.754,
    y2: 705.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#209f37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#229f36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#44a72f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5ead2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#71b226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#7db524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#81b624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#b7c91c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#aac408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#1c9f38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c9f38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_54",
    "data-name": "Rect\\xE1ngulo 54",
    width: 40.652,
    height: 2.224,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -33.192,
    y1: 706.53,
    x2: -33.167,
    y2: 706.53,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85468d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#975897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#aa6ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#b676a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ba7aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#bb4a8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#8e488e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#cd006a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd006a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_56",
    "data-name": "Rect\\xE1ngulo 56",
    width: 25.716,
    height: 2.224,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -53.58,
    y1: 709.285,
    x2: -53.54,
    y2: 709.285,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d66a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#2a78b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#3c92cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#4aa5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#52b1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#55b5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#4272b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#81c0e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e3c8a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_58",
    "data-name": "Rect\\xE1ngulo 58",
    width: 15.866,
    height: 2.224,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -87.174,
    y1: 713.94,
    x2: -87.11,
    y2: 713.94,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea8018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#ea8416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#f09e0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#f3b105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#f6bd01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#f7c100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#ea8934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#e26031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc312d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M1343.3-218.56a1.754,1.754,0,0,0-.535.567c-.593.963-1.162,1.941-1.817,3.046l.657-.084c2-.239,3.993-.522,5.994-.7a5.5,5.5,0,0,0,4.042-3.173,8.713,8.713,0,0,0-3.666-.676,9.673,9.673,0,0,0-4.675,1.022",
    transform: "translate(-1340.947 219.582)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -120.331,
    y1: 353.609,
    x2: -120.236,
    y2: 353.609,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M1348.287-225.267c.2.064.252.106.293.093a18.159,18.159,0,0,1,8.228-.718.621.621,0,0,0,.523-.166c.828-1.316,1.625-2.653,2.548-4.174-.347-.021-.687-.032-1.024-.032a13.523,13.523,0,0,0-10.569,5",
    transform: "translate(-1348.287 230.264)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -112.169,
    y1: 322.669,
    x2: -112.081,
    y2: 322.669,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M1347.858-223.438a5.673,5.673,0,0,0-3.358,2.892c.2.036.277.077.346.06a18.5,18.5,0,0,1,7.825-.337.632.632,0,0,0,.479-.073,11.769,11.769,0,0,0,2.533-3.146,7.963,7.963,0,0,0-1.932-.19,25.411,25.411,0,0,0-5.892.8",
    transform: "translate(-1344.5 224.233)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -115.694,
    y1: 436.121,
    x2: -115.603,
    y2: 436.121,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M1340.05-213.019a4.161,4.161,0,0,0-1.641,3.429c1.642-.392,3.164-.794,4.7-1.112,1.833-.38,2.733-1.791,3.644-3.448a9.582,9.582,0,0,0-2.277-.291,7.524,7.524,0,0,0-4.424,1.423",
    transform: "translate(-1338.409 214.442)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -151.258,
    y1: 339.055,
    x2: -151.136,
    y2: 339.055,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M1360.4-249.509a47.483,47.483,0,0,1-3.063,5.661c-1.9,2.631-1.633,5.788-2.581,8.636a29.058,29.058,0,0,0,5.962-14.916c-.107.206-.21.415-.318.619",
    transform: "translate(-1354.758 250.128)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -207.647,
    y1: 114.088,
    x2: -207.476,
    y2: 114.088,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#066b30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#0d6f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#2f862e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    stopColor: "#49972e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#5ca42d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#68ab2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#6cae2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#4fa732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#80b526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80b526"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M1353.647-230.994a16.907,16.907,0,0,1,6.509-1.273.825.825,0,0,0,.559-.415,10.515,10.515,0,0,0,1.189-4.654,21.277,21.277,0,0,0-8.257,6.342",
    transform: "translate(-1353.647 237.336)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -154.575,
    y1: 263.143,
    x2: -154.451,
    y2: 263.143,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M1337.6-205.776a9.807,9.807,0,0,0,.05,5.025c1.725-2.738,3.4-5.4,5.091-8.083a.659.659,0,0,0-.216-.1,4.463,4.463,0,0,0-1.137-.153,3.918,3.918,0,0,0-3.787,3.312",
    transform: "translate(-1337.302 209.088)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -134.841,
    y1: 263.185,
    x2: -134.726,
    y2: 263.185,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M1348.232-234c-.17,1.158-.328,2.321-.581,3.462-.348,1.575-.779,3.131-1.228,4.905,3.236-1.1,4.8-8.376,3.793-10.752-.725.76-1.8,1.127-1.984,2.384",
    transform: "translate(-1346.423 236.389)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -242.64,
    y1: 160.016,
    x2: -242.428,
    y2: 160.016,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M1336.4-206.134a.456.456,0,0,0,.221-.289c.674-3.2,1.387-6.4,2-9.617a6.275,6.275,0,0,0-.643-4.044,27.326,27.326,0,0,0-1.574,13.95",
    transform: "translate(-1336.093 220.084)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -326.655,
    y1: 126.343,
    x2: -326.335,
    y2: 126.343,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M1339.7-223.846a1.9,1.9,0,0,0-.142,1.193,19.536,19.536,0,0,1,.366,6.709c1.885-1.615,3.2-9.235,1.945-11.718-.775,1.349-1.51,2.561-2.169,3.816",
    transform: "translate(-1339.515 227.662)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -292.434,
    y1: 150.007,
    x2: -292.154,
    y2: 150.007,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M1345.24-231.494a3.159,3.159,0,0,0-1.214,2.961,10.677,10.677,0,0,1-.1,2.5c-.179,1.568-.419,3.129-.637,4.7,2.012-1.089,4.118-7.741,2.788-10.955-.287.271-.554.541-.838.789",
    transform: "translate(-1343.29 232.283)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -268.099,
    y1: 159.335,
    x2: -267.852,
    y2: 159.335,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M1357.334-236.082c.018.055.037.11.055.165q2.257-1.931,4.507-3.87a.661.661,0,0,0,.189-.392,24.139,24.139,0,0,0-.268-6.329c-1.5,3.5-2.995,6.962-4.484,10.426",
    transform: "translate(-1357.334 246.508)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -242.44,
    y1: 161.874,
    x2: -242.236,
    y2: 161.874,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M1352.33-238.686a1.1,1.1,0,0,0-.276.607c-.31,2.519-.6,5.04-.9,7.552a6.087,6.087,0,0,0,2.294-3.251c.307-1.283.589-2.576.8-3.878.147-.911.153-1.841.24-3-.864.782-1.526,1.358-2.157,1.969",
    transform: "translate(-1351.156 240.655)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -336.79,
    y1: 172.688,
    x2: -336.484,
    y2: 172.688,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4388",
    "data-name": "Grupo 4388",
    transform: "translate(-123 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 123, -5)",
    filter: "url(#Rect\\xE1ngulo_2113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2113-2",
    "data-name": "Rect\\xE1ngulo 2113",
    d: "M0,0H182a0,0,0,0,1,0,0V141.687A91.313,91.313,0,0,1,90.687,233h0A90.687,90.687,0,0,1,0,142.313V0A0,0,0,0,1,0,0Z",
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4381",
    "data-name": "Grupo 4381",
    transform: "translate(-3494.637 1355.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_138",
    "data-name": "Trazado 138",
    d: "M1286.747-197.233h4.22l5.99,9.793h.04v-9.793h3.1v14.091h-4.06l-6.15-10.031h-.04v10.031h-3.1Z",
    transform: "translate(2360.552 -1014.074)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_139",
    "data-name": "Trazado 139",
    d: "M1301.928-190.181a7.964,7.964,0,0,1,.568-3.065,6.728,6.728,0,0,1,1.582-2.339,6.986,6.986,0,0,1,2.408-1.483,8.7,8.7,0,0,1,3.046-.517,8.7,8.7,0,0,1,3.044.517,6.982,6.982,0,0,1,2.408,1.483,6.728,6.728,0,0,1,1.583,2.339,7.964,7.964,0,0,1,.567,3.065,7.964,7.964,0,0,1-.567,3.065,6.728,6.728,0,0,1-1.583,2.339,6.967,6.967,0,0,1-2.408,1.483,8.694,8.694,0,0,1-3.044.517,8.7,8.7,0,0,1-3.046-.517,6.971,6.971,0,0,1-2.408-1.483,6.728,6.728,0,0,1-1.582-2.339,7.964,7.964,0,0,1-.568-3.065m3.225,0a5.169,5.169,0,0,0,.308,1.821,4.163,4.163,0,0,0,.885,1.432,4.048,4.048,0,0,0,1.383.946,4.62,4.62,0,0,0,1.8.338,4.617,4.617,0,0,0,1.8-.338,4.041,4.041,0,0,0,1.383-.946,4.154,4.154,0,0,0,.885-1.432,5.147,5.147,0,0,0,.31-1.821,5.172,5.172,0,0,0-.31-1.811,4.156,4.156,0,0,0-.885-1.443,4.053,4.053,0,0,0-1.383-.945,4.617,4.617,0,0,0-1.8-.338,4.62,4.62,0,0,0-1.8.338,4.06,4.06,0,0,0-1.383.945,4.164,4.164,0,0,0-.885,1.443,5.194,5.194,0,0,0-.308,1.811",
    transform: "translate(2360.833 -1014.068)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_140",
    "data-name": "Trazado 140",
    d: "M1317.56-197.233h3.543l3.482,9.235h.041l3.543-9.235h3.323l-5.812,14.091h-2.487Z",
    transform: "translate(2361.125 -1014.074)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_141",
    "data-name": "Trazado 141",
    d: "M1336.273-197.233h2.567l6.131,14.091h-3.5l-1.214-2.985h-5.474l-1.175,2.985h-3.422Zm1.194,4.1-1.711,4.378h3.443Z",
    transform: "translate(2361.359 -1014.074)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_142",
    "data-name": "Trazado 142",
    d: "M1355.316-193.565a3.057,3.057,0,0,0-1.125-.856,3.735,3.735,0,0,0-1.543-.3,3.886,3.886,0,0,0-1.622.338,3.883,3.883,0,0,0-1.294.945,4.412,4.412,0,0,0-.855,1.443,5.186,5.186,0,0,0-.308,1.811,5.156,5.156,0,0,0,.308,1.82,4.531,4.531,0,0,0,.845,1.433,3.834,3.834,0,0,0,1.264.946,3.66,3.66,0,0,0,1.563.338,3.511,3.511,0,0,0,1.692-.4,3.368,3.368,0,0,0,1.213-1.114l2.588,1.93a5.379,5.379,0,0,1-2.269,1.851,7.016,7.016,0,0,1-2.826.6,8.7,8.7,0,0,1-3.046-.517,6.971,6.971,0,0,1-2.408-1.483,6.724,6.724,0,0,1-1.582-2.339,7.95,7.95,0,0,1-.568-3.065,7.955,7.955,0,0,1,.568-3.066,6.72,6.72,0,0,1,1.582-2.338,6.971,6.971,0,0,1,2.408-1.483,8.7,8.7,0,0,1,3.046-.517,7.425,7.425,0,0,1,1.244.11,6.692,6.692,0,0,1,1.273.347,5.8,5.8,0,0,1,1.2.637,4.9,4.9,0,0,1,1.035.976Z",
    transform: "translate(2361.64 -1014.068)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_143",
    "data-name": "Trazado 143",
    d: "M1359.59-197.233h9.573v2.866h-6.468v2.627h6.11v2.866h-6.11v2.866h6.827v2.865h-9.931Z",
    transform: "translate(2361.905 -1014.074)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_144",
    "data-name": "Trazado 144",
    d: "M1371.782-197.233H1376l5.989,9.793h.041v-9.793h3.1v14.091h-4.059l-6.151-10.031h-.039v10.031h-3.1Z",
    transform: "translate(2362.132 -1014.074)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_145",
    "data-name": "Trazado 145",
    d: "M1390.457-194.487h-4.02v-2.747h11.144v2.747h-4.019v11.344h-3.1Z",
    transform: "translate(2362.403 -1014.074)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_146",
    "data-name": "Trazado 146",
    d: "M1398.921-197.233h5.453a9.615,9.615,0,0,1,2.04.209,4.864,4.864,0,0,1,1.692.7,3.488,3.488,0,0,1,1.154,1.314,4.448,4.448,0,0,1,.427,2.06,4.135,4.135,0,0,1-.775,2.537,3.5,3.5,0,0,1-2.27,1.324l3.582,5.951H1406.5l-2.945-5.633h-1.533v5.633h-3.1Zm3.1,5.831h1.831c.278,0,.572-.01.885-.03a2.771,2.771,0,0,0,.845-.179,1.468,1.468,0,0,0,.628-.467,1.431,1.431,0,0,0,.249-.9,1.5,1.5,0,0,0-.218-.857,1.474,1.474,0,0,0-.558-.487,2.461,2.461,0,0,0-.776-.229,6.336,6.336,0,0,0-.856-.06h-2.03Z",
    transform: "translate(2362.636 -1014.074)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_147",
    "data-name": "Trazado 147",
    d: "M1410.842-190.181a7.961,7.961,0,0,1,.567-3.065,6.719,6.719,0,0,1,1.581-2.339,6.99,6.99,0,0,1,2.41-1.483,8.691,8.691,0,0,1,3.044-.517,8.7,8.7,0,0,1,3.044.517,6.985,6.985,0,0,1,2.408,1.483,6.728,6.728,0,0,1,1.583,2.339,7.968,7.968,0,0,1,.567,3.065,7.968,7.968,0,0,1-.567,3.065,6.728,6.728,0,0,1-1.583,2.339,6.969,6.969,0,0,1-2.408,1.483,8.7,8.7,0,0,1-3.044.517,8.69,8.69,0,0,1-3.044-.517,6.974,6.974,0,0,1-2.41-1.483,6.719,6.719,0,0,1-1.581-2.339,7.961,7.961,0,0,1-.567-3.065m3.224,0a5.169,5.169,0,0,0,.309,1.821,4.171,4.171,0,0,0,.885,1.432,4.053,4.053,0,0,0,1.383.946,4.621,4.621,0,0,0,1.8.338,4.621,4.621,0,0,0,1.8-.338,4.045,4.045,0,0,0,1.383-.946,4.141,4.141,0,0,0,.885-1.432,5.164,5.164,0,0,0,.31-1.821,5.189,5.189,0,0,0-.31-1.811,4.143,4.143,0,0,0-.885-1.443,4.056,4.056,0,0,0-1.383-.945,4.621,4.621,0,0,0-1.8-.338,4.621,4.621,0,0,0-1.8.338,4.065,4.065,0,0,0-1.383.945,4.173,4.173,0,0,0-.885,1.443,5.194,5.194,0,0,0-.309,1.811",
    transform: "translate(2362.857 -1014.068)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_148",
    "data-name": "Trazado 148",
    d: "M1301.59-177.874h2a2.332,2.332,0,0,1,.9.149,1.519,1.519,0,0,1,.557.377,1.27,1.27,0,0,1,.284.512,2,2,0,0,1,.081.549,2,2,0,0,1-.081.549,1.281,1.281,0,0,1-.284.513,1.53,1.53,0,0,1-.557.376,2.333,2.333,0,0,1-.9.149h-1.226v2.5h-.769Zm.769,2.5h1.011a2.815,2.815,0,0,0,.444-.036,1.211,1.211,0,0,0,.393-.132.721.721,0,0,0,.276-.277.931.931,0,0,0,.1-.469.931.931,0,0,0-.1-.469.711.711,0,0,0-.276-.276,1.164,1.164,0,0,0-.393-.132,2.7,2.7,0,0,0-.444-.037h-1.011Z",
    transform: "translate(2360.828 -1011.544)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_149",
    "data-name": "Trazado 149",
    d: "M1310.235-177.874h.7l2.428,5.675h-.9l-.569-1.4h-2.7l-.561,1.4h-.9Zm1.379,3.6-1.058-2.606h-.015l-1.075,2.606Z",
    transform: "translate(2360.941 -1011.544)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_150",
    "data-name": "Trazado 150",
    d: "M1316.346-173.384a1.268,1.268,0,0,0,.533.461,1.6,1.6,0,0,0,.669.148,1.344,1.344,0,0,0,.393-.06,1.209,1.209,0,0,0,.364-.18,1.011,1.011,0,0,0,.269-.3.8.8,0,0,0,.1-.409.614.614,0,0,0-.209-.5,1.8,1.8,0,0,0-.517-.288c-.207-.078-.431-.153-.673-.225a2.694,2.694,0,0,1-.673-.3,1.647,1.647,0,0,1-.517-.516,1.616,1.616,0,0,1-.209-.878,1.472,1.472,0,0,1,.109-.529,1.5,1.5,0,0,1,.34-.513,1.879,1.879,0,0,1,.6-.388,2.211,2.211,0,0,1,.878-.156,3.055,3.055,0,0,1,.889.128,1.527,1.527,0,0,1,.746.519l-.625.569a1.032,1.032,0,0,0-.409-.361,1.3,1.3,0,0,0-.6-.136,1.457,1.457,0,0,0-.533.085.953.953,0,0,0-.341.217.753.753,0,0,0-.18.284.865.865,0,0,0-.052.28.715.715,0,0,0,.209.553,1.613,1.613,0,0,0,.516.313,6.424,6.424,0,0,0,.673.216,2.908,2.908,0,0,1,.673.269,1.578,1.578,0,0,1,.518.464,1.373,1.373,0,0,1,.208.806,1.7,1.7,0,0,1-.156.737,1.648,1.648,0,0,1-.421.553,1.868,1.868,0,0,1-.625.344,2.409,2.409,0,0,1-.769.12,2.811,2.811,0,0,1-1.034-.191,1.7,1.7,0,0,1-.778-.594Z",
    transform: "translate(2361.09 -1011.539)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_151",
    "data-name": "Trazado 151",
    d: "M1324.524-177.874h.7l2.427,5.675h-.9l-.569-1.4h-2.7l-.561,1.4h-.9Zm1.378,3.6-1.058-2.606h-.015l-1.073,2.606Z",
    transform: "translate(2361.207 -1011.544)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_152",
    "data-name": "Trazado 152",
    d: "M1332.24-177.874h.769v4.055a1.988,1.988,0,0,1-.168.878,1.53,1.53,0,0,1-.421.537,1.509,1.509,0,0,1-.541.272,2.085,2.085,0,0,1-.53.076,1.644,1.644,0,0,1-1.013-.309,1.422,1.422,0,0,1-.525-.934l.753-.168a.908.908,0,0,0,.265.505.742.742,0,0,0,.52.184.841.841,0,0,0,.461-.112.786.786,0,0,0,.269-.293,1.216,1.216,0,0,0,.127-.413,3.408,3.408,0,0,0,.033-.473Z",
    transform: "translate(2361.352 -1011.53)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_153",
    "data-name": "Trazado 153",
    d: "M1336.437-177.874h3.663v.721h-2.894v1.691h2.693v.721h-2.693v1.819h3.037v.721h-3.806Z",
    transform: "translate(2361.475 -1011.545)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_154",
    "data-name": "Trazado 154",
    d: "M1351.764-176.645a1.575,1.575,0,0,0-.609-.481,1.8,1.8,0,0,0-.761-.169,2.043,2.043,0,0,0-.87.181,2,2,0,0,0-.665.492,2.263,2.263,0,0,0-.429.733,2.626,2.626,0,0,0-.152.9,2.5,2.5,0,0,0,.144.848,2.12,2.12,0,0,0,.417.706,1.96,1.96,0,0,0,.665.481,2.141,2.141,0,0,0,.89.176,1.773,1.773,0,0,0,.858-.2,1.854,1.854,0,0,0,.624-.561l.65.489a2.769,2.769,0,0,1-.225.253,2.244,2.244,0,0,1-.425.328,3.027,3.027,0,0,1-.637.288,2.7,2.7,0,0,1-.862.124,2.8,2.8,0,0,1-1.214-.257,2.928,2.928,0,0,1-.922-.672,2.937,2.937,0,0,1-.581-.942,2.936,2.936,0,0,1-.2-1.061,3.34,3.34,0,0,1,.216-1.214,2.852,2.852,0,0,1,.606-.962,2.7,2.7,0,0,1,.933-.629,3.126,3.126,0,0,1,1.2-.224,2.957,2.957,0,0,1,1.1.216,2.053,2.053,0,0,1,.885.665Z",
    transform: "translate(2361.68 -1011.539)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_155",
    "data-name": "Trazado 155",
    d: "M1358.144-172.053a3.065,3.065,0,0,1-1.194-.228,2.8,2.8,0,0,1-.934-.629,2.913,2.913,0,0,1-.609-.945,3.12,3.12,0,0,1-.22-1.178,3.114,3.114,0,0,1,.22-1.177,2.907,2.907,0,0,1,.609-.946,2.8,2.8,0,0,1,.934-.629,3.066,3.066,0,0,1,1.194-.228,3.066,3.066,0,0,1,1.194.228,2.784,2.784,0,0,1,.934.629,2.925,2.925,0,0,1,.61.946,3.133,3.133,0,0,1,.219,1.177,3.138,3.138,0,0,1-.219,1.178,2.932,2.932,0,0,1-.61.945,2.783,2.783,0,0,1-.934.629,3.065,3.065,0,0,1-1.194.228m0-.721a2.09,2.09,0,0,0,.881-.18,2.089,2.089,0,0,0,.673-.485,2.12,2.12,0,0,0,.433-.717,2.506,2.506,0,0,0,.153-.878,2.51,2.51,0,0,0-.153-.878,2.12,2.12,0,0,0-.433-.717,2.088,2.088,0,0,0-.673-.485,2.105,2.105,0,0,0-.881-.18,2.1,2.1,0,0,0-.881.18,2.086,2.086,0,0,0-.673.485,2.13,2.13,0,0,0-.433.717,2.513,2.513,0,0,0-.153.878,2.509,2.509,0,0,0,.153.878,2.13,2.13,0,0,0,.433.717,2.086,2.086,0,0,0,.673.485,2.086,2.086,0,0,0,.881.18",
    transform: "translate(2361.823 -1011.539)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_156",
    "data-name": "Trazado 156",
    d: "M1364.211-177.874h1.146l1.8,4.3h.033l1.786-4.3h1.146v5.674h-.769v-4.664h-.016l-1.916,4.664h-.512L1365-176.865h-.015v4.664h-.77Z",
    transform: "translate(2361.991 -1011.545)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_157",
    "data-name": "Trazado 157",
    d: "M1373.582-177.874h3.663v.721h-2.893v1.691h2.692v.721h-2.692v1.819h3.036v.721h-3.806Z",
    transform: "translate(2362.165 -1011.545)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_158",
    "data-name": "Trazado 158",
    d: "M1380.577-177.874h2a2.34,2.34,0,0,1,.9.149,1.514,1.514,0,0,1,.556.377,1.267,1.267,0,0,1,.285.512,2.038,2.038,0,0,1,.08.549,1.456,1.456,0,0,1-.1.525,1.5,1.5,0,0,1-.276.457,1.594,1.594,0,0,1-.442.344,1.523,1.523,0,0,1-.58.172l1.611,2.589h-.962l-1.442-2.5h-.859v2.5h-.769Zm.769,2.5h1.01a2.832,2.832,0,0,0,.445-.036,1.2,1.2,0,0,0,.392-.132.715.715,0,0,0,.277-.277.94.94,0,0,0,.1-.469.94.94,0,0,0-.1-.469.706.706,0,0,0-.277-.276,1.156,1.156,0,0,0-.392-.132,2.716,2.716,0,0,0-.445-.037h-1.01Z",
    transform: "translate(2362.295 -1011.544)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_159",
    "data-name": "Trazado 159",
    d: "M1391.53-176.645a1.579,1.579,0,0,0-.609-.481,1.807,1.807,0,0,0-.762-.169,2.041,2.041,0,0,0-.869.181,2,2,0,0,0-.666.492,2.259,2.259,0,0,0-.428.733,2.626,2.626,0,0,0-.153.9,2.5,2.5,0,0,0,.145.848,2.1,2.1,0,0,0,.417.706,1.957,1.957,0,0,0,.665.481,2.139,2.139,0,0,0,.889.176,1.766,1.766,0,0,0,.858-.2,1.855,1.855,0,0,0,.625-.561l.649.489a2.735,2.735,0,0,1-.224.253,2.262,2.262,0,0,1-.425.328,3.005,3.005,0,0,1-.637.288,2.7,2.7,0,0,1-.861.124,2.8,2.8,0,0,1-1.215-.257,2.935,2.935,0,0,1-.921-.672,2.934,2.934,0,0,1-.581-.942,2.943,2.943,0,0,1-.2-1.061,3.335,3.335,0,0,1,.217-1.214,2.867,2.867,0,0,1,.605-.962,2.709,2.709,0,0,1,.934-.629,3.121,3.121,0,0,1,1.2-.224,2.958,2.958,0,0,1,1.1.216,2.061,2.061,0,0,1,.885.665Z",
    transform: "translate(2362.418 -1011.539)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_50",
    "data-name": "Rect\\xE1ngulo 50",
    width: 0.769,
    height: 5.673,
    transform: "translate(3757.867 -1189.419)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_160",
    "data-name": "Trazado 160",
    d: "M1401.464-177.874h.7l2.428,5.675h-.9l-.57-1.4h-2.7l-.561,1.4h-.9Zm1.379,3.6-1.058-2.606h-.016l-1.072,2.606Z",
    transform: "translate(2362.637 -1011.544)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_161",
    "data-name": "Trazado 161",
    d: "M1407.4-177.874h.77v4.952h2.6v.721H1407.4Z",
    transform: "translate(2362.793 -1011.545)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_116",
    "data-name": "Grupo 116",
    transform: "translate(3647.224 -1194.575)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_51",
    "data-name": "Rect\\xE1ngulo 51",
    width: 59.544,
    height: 2.224,
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_117",
    "data-name": "Grupo 117",
    transform: "translate(3706.768 -1194.575)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_53",
    "data-name": "Rect\\xE1ngulo 53",
    width: 40.652,
    height: 2.224,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_118",
    "data-name": "Grupo 118",
    transform: "translate(3747.418 -1194.575)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_55",
    "data-name": "Rect\\xE1ngulo 55",
    width: 25.716,
    height: 2.224,
    transform: "translate(0)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_119",
    "data-name": "Grupo 119",
    transform: "translate(3773.135 -1194.575)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_57",
    "data-name": "Rect\\xE1ngulo 57",
    width: 15.866,
    height: 2.224,
    transform: "translate(0)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_120",
    "data-name": "Grupo 120",
    transform: "translate(3697.561 -1271.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M1374.864-240.022h-9.347v24.6c-2.748-3.349-5.541-7.054-8.077-10.146a21.952,21.952,0,0,1-2.261,3.659,18.694,18.694,0,0,1-3.512,3.758c5.05,6.151,10.045,12.24,15.056,18.317a1.3,1.3,0,0,0,.8.509c2.432.041,4.865.024,7.344.024Z",
    transform: "translate(-1335.803 250.316)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M1374.864-240.022h-9.347v24.6c-2.748-3.349-5.541-7.054-8.077-10.146a21.952,21.952,0,0,1-2.261,3.659,18.694,18.694,0,0,1-3.512,3.758c5.05,6.151,10.045,12.24,15.056,18.317a1.3,1.3,0,0,0,.8.509c2.432.041,4.865.024,7.344.024Z",
    transform: "translate(-1335.803 250.316)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M1337.795-220.538v-19.553c2.5,0,4.974-.018,7.447.024.264,0,.571.317.774.555.96,1.134,2.239,2.167,3.31,3.475a42.8,42.8,0,0,0-7.287,7.722,27.454,27.454,0,0,0-4.245,7.776",
    transform: "translate(-1336.061 250.314)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(4.944 31.114)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_14",
    "data-name": "Rect\\xE1ngulo 14",
    width: 10.693,
    height: 4.635,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(12.421 20.233)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 11.592,
    height: 5.103,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32",
    transform: "translate(8.563 26.376)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_16",
    "data-name": "Rect\\xE1ngulo 16",
    width: 11.183,
    height: 3.765,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    transform: "translate(2.359 36.349)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17",
    "data-name": "Rect\\xE1ngulo 17",
    width: 8.342,
    height: 4.851,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36",
    transform: "translate(19.012)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_18",
    "data-name": "Rect\\xE1ngulo 18",
    width: 5.962,
    height: 14.916,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38",
    transform: "translate(17.88 13.03)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_19",
    "data-name": "Rect\\xE1ngulo 19",
    width: 8.257,
    height: 6.342,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_40",
    "data-name": "Grupo 40",
    transform: "translate(1.232 41.803)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_20",
    "data-name": "Rect\\xE1ngulo 20",
    width: 8.88,
    height: 6.431,
    transform: "translate(-0.993 8.244) rotate(-83.936)",
    fill: "url(#linear-gradient-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42",
    "data-name": "Grupo 42",
    transform: "translate(10.522 13.994)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_21",
    "data-name": "Rect\\xE1ngulo 21",
    width: 4.801,
    height: 10.752,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(0 30.602)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22",
    "data-name": "Rect\\xE1ngulo 22",
    width: 3.178,
    height: 13.951,
    transform: "translate(-0.409 0)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_46",
    "data-name": "Grupo 46",
    transform: "translate(3.486 22.883)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_23",
    "data-name": "Rect\\xE1ngulo 23",
    width: 3.648,
    height: 11.718,
    transform: "translate(-0.045 0)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_48",
    "data-name": "Grupo 48",
    transform: "translate(7.331 18.177)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24",
    "data-name": "Rect\\xE1ngulo 24",
    width: 4.118,
    height: 10.955,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_50",
    "data-name": "Grupo 50",
    transform: "translate(21.636 3.687)",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25",
    "data-name": "Rect\\xE1ngulo 25",
    width: 4.984,
    height: 10.591,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_52",
    "data-name": "Grupo 52",
    transform: "translate(15.343 9.649)",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26",
    "data-name": "Rect\\xE1ngulo 26",
    width: 3.332,
    height: 10.128,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-17)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M1347.463-214.064l-.107,14.247h-9.529l4.818-7.529",
    transform: "translate(-1336.061 250.798)",
    fill: "#1d1d1b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogofondo);
export default __webpack_public_path__ + "static/media/logofondo.ff8389a99e51cf9d121eb6fcf87e7107.svg";
export { ForwardRef as ReactComponent };